module.exports = __webpack_public_path__ + "static/media/crm.60d5ea1d.png";